/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RemoveOrganizationUserSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RemoveOrganizationUserRequest = {
  /**
   * Speakeasy user ID to remove.
   */
  userId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type RemoveOrganizationUserSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RemoveOrganizationUserSecurity$outboundSchema: z.ZodMiniType<
  RemoveOrganizationUserSecurity$Outbound,
  RemoveOrganizationUserSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function removeOrganizationUserSecurityToJSON(
  removeOrganizationUserSecurity: RemoveOrganizationUserSecurity,
): string {
  return JSON.stringify(
    RemoveOrganizationUserSecurity$outboundSchema.parse(
      removeOrganizationUserSecurity,
    ),
  );
}

/** @internal */
export type RemoveOrganizationUserRequest$Outbound = {
  user_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const RemoveOrganizationUserRequest$outboundSchema: z.ZodMiniType<
  RemoveOrganizationUserRequest$Outbound,
  RemoveOrganizationUserRequest
> = z.pipe(
  z.object({
    userId: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      userId: "user_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function removeOrganizationUserRequestToJSON(
  removeOrganizationUserRequest: RemoveOrganizationUserRequest,
): string {
  return JSON.stringify(
    RemoveOrganizationUserRequest$outboundSchema.parse(
      removeOrganizationUserRequest,
    ),
  );
}
